'use strict';

var angular = require('angular');

function navigationProvider() {
  var routes = [];

  return {
    when: when,
    $get: $get
  };

  function when(path, config) {
    if (!config.hasOwnProperty('enable')) {
      config.enable = _defaultEnabled;
    }

    routes.push(angular.extend({ path: path, regexp: new RegExp(path) }, config));
    return this;
  }

  function $get() {
    return {
      routes: routes
    };
  }

  function _defaultEnabled() {
    return true;
  }
}

module.exports = navigationProvider;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/navigation-bar/provider/index.js
 ** module id = 137
 ** module chunks = 0
 **/